import React from 'react'
import { Link } from 'react-router-dom'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PasswordOutlinedIcon from '@mui/icons-material/PasswordOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import { useLanguage } from '../context/LanguageContext';


const Footer = () => {
  const { t } = useLanguage();

  return (
    <div className='Footer-wrapper'>
      <div className='Foolter-list'>
        <Link to="/"><HomeOutlinedIcon />{t('footer_home')}</Link>
        <Link to="/about"><PasswordOutlinedIcon />{t('footer_about')}</Link>
        <Link to="/More"><SmsOutlinedIcon />{t('footer_more')}</Link>
      </div>
    </div>
  )
}

export default Footer
